import { render, staticRenderFns } from "./drupal-color.vue?vue&type=template&id=382a3246&"
import script from "./drupal-color.vue?vue&type=script&lang=js&"
export * from "./drupal-color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports